import { render, staticRenderFns } from "./commonSvg.vue?vue&type=template&id=03edd8f6&scoped=true"
import script from "./commonSvg.vue?vue&type=script&lang=js"
export * from "./commonSvg.vue?vue&type=script&lang=js"
import style0 from "./commonSvg.vue?vue&type=style&index=0&id=03edd8f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../ymoffers/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03edd8f6",
  null
  
)

export default component.exports